import CharacterHeaderTablet from './CharacterHeaderTablet';

export default CharacterHeaderTablet;
export { CharacterHeaderTablet };
